import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data20ir384tdyz1e as Data } from '../SaveBoostMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.z6u_1 = listOf('saveBoost');
      }
      s41(reader, customScalarAdapters) {
        var _saveBoost = null;
        $l$loop: while (true) {
          if (reader.m4g(this.z6u_1) === 0)
            _saveBoost = get_NullableBooleanAdapter().s41(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_saveBoost);
      }
      a6v(writer, customScalarAdapters, value) {
        writer.k4e('saveBoost');
        get_NullableBooleanAdapter().x41(writer, customScalarAdapters, value.d6s_1);
      }
      t41(writer, customScalarAdapters, value) {
        return this.a6v(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance2dx6odfkdwlsm,
};
//endregion

//# sourceMappingURL=SaveBoostMutation_ResponseAdapter.mjs.map
